import { SVGS } from '@zonofi/zono-money-design-system';
import { WEBROUTES } from '@zonofi/zono-money-helpers';
import { dispatch, updateIsSideDrawerOpen } from '@zonofi/zono-money-store';
import { useMemo } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

export const useSideDrawer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const inviteId = searchParams.get('inviteId');
  const sellerWorkspaceId = searchParams.get('sellerWorkspaceId');

  const addRequiredParams = (url: string) => {
    const separator = url.includes('?') ? '&' : '?';

    return `${url}${separator}token=${encodeURIComponent(token)}&inviteId=${encodeURIComponent(
      inviteId
    )}&sellerWorkspaceId=${encodeURIComponent(sellerWorkspaceId)}`;
  };

  const sideDrawerItems = useMemo(() => {
    return [
      {
        label: 'View Catalogue',
        onClick: () => {
          navigate(addRequiredParams(WEBROUTES.CATALOGUE));
          dispatch(updateIsSideDrawerOpen(false));
        },
        icon: SVGS.CatalogueOutlineBlack,
      },
      {
        label: 'Invoices',
        onClick: () => {
          navigate(addRequiredParams(WEBROUTES.INVOICE_SCREEN));
          dispatch(updateIsSideDrawerOpen(false));
        },
        icon: SVGS.InvoiceIconOutlineBlack,
      },
      {
        label: 'Ledger',
        onClick: () => {
          navigate(addRequiredParams(WEBROUTES.LEDGER));
          dispatch(updateIsSideDrawerOpen(false));
        },
        icon: SVGS.LedgerOutlineBlack,
      },
      {
        label: 'Payments',
        onClick: () => {
          navigate(addRequiredParams(WEBROUTES.PAYMENTS));
          dispatch(updateIsSideDrawerOpen(false));
        },
        icon: SVGS.PaymentOutlineBlack,
      },
      {
        label: 'Go to Seller Hub',
        onClick: () => {
          dispatch(updateIsSideDrawerOpen(false));
          let orderId = location.pathname?.split('/')?.[2];
          if (location.pathname.includes(WEBROUTES.ORDER) && orderId) {
            window.location.href = `/seller/order/details/${orderId}?source=external`;
          } else {
            window.location.href = '/seller/login?source=external';
          }
        },
      },
    ];
  }, []);
  return {
    sideDrawerItems,
  };
};
